import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { msgs } from '../msgs';

type Interface = { className: string };

const Component = observer(({ className }: Interface): ReactElement => {
	const intl = useIntl();
	return (
		<div className={className}>
			<span>{intl.formatMessage(msgs.missingRequiredData)}</span>
		</div>
	);
});

const ReloadSuggestionHeader = styled(Component)(
	({
		theme: {
			blockedChat: {
				header: { blockedHeader },
			},
		},
	}: {
		theme: Theme;
	}) => blockedHeader,
	css`
		display: flex;
		flex-direction: column;
		position: relative;

		span {
			font-weight: bold;
		}
	`
);

export { ReloadSuggestionHeader };
